import { render, staticRenderFns } from "./CustomerPhase.vue?vue&type=template&id=955f8430&scoped=true"
import script from "./CustomerPhase.vue?vue&type=script&lang=js"
export * from "./CustomerPhase.vue?vue&type=script&lang=js"
import style0 from "./CustomerPhase.vue?vue&type=style&index=0&id=955f8430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955f8430",
  null
  
)

export default component.exports